// Make jQuery events observable by native event listeners
// =======================================================
//
// Non-jQuery libraries (such as Unpoly) cannot observe pure jQuery events
// triggered by jQuery plugins (like select2 or bootstrap-datepicker).
//
// This function can be applied to a jQuery element known to emit pure jQuery events.
// If it observes a pure jQuery event without an underlying native event, the jQuery
// event is stopped from propagation and bubbling. A native event is then emitted on the
// same element.
//
// Make sure this function is applied before any other event listeners are registered
// to the given jQuery element, or events might be received twice.
//
jQuery.fn.enableNativeEvent = function(eventName, convertedPropNames = []) {
  this.on(eventName, function($event) {
    // Only convert when there is not already a native event
    if (!$event.originalEvent) {
      let eventProps = up.util.pick($event, convertedPropNames)
      up.emit($event.target, eventName, eventProps)
      up.event.halt($event)
    }

  })

  return this
}
